import React from 'react';
// @ts-ignore
import styles from './QuestionnaireResultTable.module.scss';
import { IQuestionnaireResultTable } from '../../Models/Questionnaire/IQuestionnaireResultTable';
import Table from '../Table/Table';
import QuestionnaireResultTableItem from './QuestionnaireResultTableItem';
import Text from '../Base/Text/Text';
import { useAppContext } from '../../Services/AppContext';
import NetteApiClient from '../../Services/NetteApiClient';
import { useEffectAsync } from '../../helpers';
import apiClient from '../../Services/ApiClient';
import { USER_HEALTH_DATA } from '../UserInfo/UserData';
import { useState } from 'react';
import Loading from '../Loading';
import Moment from 'react-moment';
import { format } from 'date-fns';
// @ts-ignore
import moment from 'moment';
import { formatQueryString } from '../../Services/Api/FormatQueryString';

export default function QuestionnaireResultTable(
	props: IQuestionnaireResultTable,
) {
	const { patientId, allowShowMore = false, from, to, interval } = props;
	const [data, setData] = useState([]);
	const [labels, setLabels] = useState([]);
	const { translation } = useAppContext();

	// @ts-ignore
	useEffectAsync(async () => {
		const tempData = [];
		const tempLabels = [
			{
				key: 'name',
				title: '',
				colSpan: 3,
				renderItem: item => {
					return <div className='px-3'>{item.name}</div>;
				},
			},
		];

		if (from && to && patientId && interval) {
			const query = formatQueryString({
				view: interval,
				start: moment(from).toISOString(),
				end: moment(to).toISOString(),
				keys: ['weight', 'waistline', 'heart_rate'],
				type: 'default',
			});
			const { data } = await apiClient.get(
				'/user/' + patientId + '/health-data/chart?' + query,
			);
			for (const row of data) {
				let tempItem;
				switch (row.key) {
					case 'weight':
						tempItem = {
							id: 1,
							name: translation['base.shared.form.weight.label2'],
							show: true,
						};
						row.data.map((rowItem, index) => {
							tempLabels.push({
								key: `day${index}`,
								title: format(new Date(rowItem.time), 'dd.MM'),
								colSpan: null,
								renderItem: item => {
									const value = item[`day${index}`];

									if (typeof value === 'undefined') {
										return <></>;
									}

									return (
										<QuestionnaireResultTableItem
											value={item[`day${index}`]?.value}
											diff={item[`day${index}`]?.diff}
											color={item[`day${index}`]?.color}
										/>
									);
								},
							});
							tempItem = {
								...tempItem,
								[`day${index}`]: {
									value: parseFloat(rowItem.value),
									diff: null,
									color: '#619612',
									textColor: '#ffffff',
								},
							};
						});
						tempData.push(tempItem);
						break;
					case 'waistline':
						tempItem = {
							id: 1,
							name: translation['base.waistline'],
							show: true,
						};
						row.data.map((rowItem, index) => {
							tempItem = {
								...tempItem,
								[`day${index}`]: {
									value: parseFloat(rowItem.value),
									diff: null,
									color: '#619612',
									textColor: '#ffffff',
								},
							};
						});
						tempData.push(tempItem);
						break;
					case 'heart_rate':
						tempItem = {
							id: 1,
							name: translation['base.heartRate'],
							show: true,
						};
						row.data.map((rowItem, index) => {
							tempItem = {
								...tempItem,
								[`day${index}`]: {
									value: parseFloat(rowItem.value),
									diff: null,
									color: '#619612',
									textColor: '#ffffff',
								},
							};
						});
						tempData.push(tempItem);
						break;
				}
			}
		}
		setData(tempData);
		setLabels(tempLabels);
	}, [from, to, interval]);

	if (!data) {
		return (
			<div className={'py-5'}>
				<Loading />
			</div>
		);
	}

	const { showHealthData } = useAppContext();

	const handleShowMore = () => {
		NetteApiClient.get(showHealthData);
	};

	return (
		<div className={styles.wrapper}>
			<div className={styles.header}>
				<Text
					className={styles.title}
					tx={'base.shared.questionnaires'}
					firstUpper
				/>
				{allowShowMore && (
					<div className={styles.button} onClick={handleShowMore}>
						<Text tx={'base.showMore'} firstUpper />
					</div>
				)}
			</div>
			<Table columns={labels} rows={data} showColumns />
		</div>
	);
}
